import React from "react";
function MockInterviewSlabDetail(props) {
    return (
        <div className="row box ">
            <div className="col-md-12">
                <p className="StepTitle" >
                    {" "}
                    Slab {props.record.slab_count > 0 ? "" : ""}{" "}
                    {props.record.slab_count > 0 ? props.record.slab_count : ""} Details
                </p>
                <div className="row mb-4" style={{ paddingRight: "20px" }}>
                    {/* Slab Name */}
                    <div className="col-md-6">
                        <div className="forms ">
                            <label for="title">
                                {" Slab Name"}
                            </label>

                            <select
                                ref={props.txtBatchSlabName}
                                className="Inputs"
                                id="name"
                                name="name"
                                value={props.record.name || ""}
                                onChange={(e) => props.examdetailschange(e, props.record.id)}
                            >
                                <option value="">Select slab name</option>
                                <option value="Outstanding">Outstanding</option>
                                <option value="Excellent">Excellent</option>
                                <option value="Very Good">Very Good</option>
                                <option value="Good">Good</option>
                                <option value="Above Average">Above Average</option>
                                <option value="Average">Average</option>
                                <option value="Satisfactory">Satisfactory</option>
                                <option value="Needs Improvement">Needs Improvement</option>
                                <option value="Below Expectations">Below Expectations</option>
                                <option value="Unsatisfactory">Unsatisfactory</option>

                            </select>
                            {props.record.error_slab_1 && (
                                <small className="error">{props.record.error_slab_1}</small>
                            )}
                        </div>
                    </div>
                    {/* Slab Mark */}
                    <div className="col-md-6">
                        <div className="forms ">
                            <label for="mark">
                                {" Slab Mark"}
                            </label>
                            <input
                                ref={props.txtBatchSlabMark}
                                type="number"
                                class="Inputs"
                                id="mark"
                                name="mark"
                                max={100}
                                placeholder="Slab mark"
                                value={props.record.mark}
                                onChange={(e) => {
                                    const value = Number(e.target.value);

                                    // ✅ React-level validation
                                    if (value > 100) return;

                                    props.examdetailschange(e, props.record.id);
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                            {props.record.error_slab_2 && (
                                <small className="error">{props.record.error_slab_2}</small>
                            )}
                        </div>
                    </div>
                    {/* Minimum Mark */}
                    <div className="col-md-6">
                        <div className="forms ">
                            <label for="min_mark">
                                {" Minimum Mark "}
                            </label>
                            <input
                                ref={props.txtBatchSlaMin}
                                type="number"
                                class="Inputs"
                                id="min_mark"
                                name="min_mark"
                                max={100}
                                placeholder="Minimum mark"
                                value={props.record.min_mark}
                                onChange={(e) => {
                                    const value = Number(e.target.value);

                                    // ✅ React-level validation
                                    if (value > 100) return;

                                    props.examdetailschange(e, props.record.id);
                                }}
                                onWheel={(e) => e.target.blur()}
                            />
                            {props.record.error_slab_3 && (
                                <small className="error">{props.record.error_slab_3}</small>
                            )}
                        </div>
                    </div>
                    {/* Maximum Mark */}
                    <div className="col-md-6">
                        <div className="forms ">
                            <label for="max_mark">
                                {" Maximum Mark "}
                            </label>
                            <input
                                ref={props.txtBatchSlabMax}
                                type="number"
                                class="Inputs"
                                id="max_mark"
                                name="max_mark"
                                max={100}
                                placeholder="Maximum mark"
                                value={props.record.max_mark}
                                readOnly
                                // onChange={(e) => {
                                //     const value = Number(e.target.value);

                                //     // ✅ React-level validation
                                //     if (value > 100) return;

                                //     props.examdetailschange(e, props.record.id);
                                // }}
                                onWheel={(e) => e.target.blur()}
                            />
                            {props.record.error_slab_4 && (
                                <small className="error">{props.record.error_slab_4}</small>
                            )}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default MockInterviewSlabDetail;
